var map = {
	"./book": 1,
	"./book.jpg": 1,
	"./browsing": 2,
	"./browsing.jpg": 2,
	"./chart": 3,
	"./chart.jpg": 3,
	"./favicon_v3.ico": 15,
	"./friend": 4,
	"./friend.jpg": 4,
	"./ipad": 5,
	"./ipad.jpg": 5,
	"./key": 6,
	"./key.jpg": 6,
	"./library": 0,
	"./library.jpg": 16,
	"./library.png": 0,
	"./relax": 7,
	"./relax.jpg": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14;